export default Object.freeze({
    IN_PERSON_ONLY: 0,
    TELEHEALTH_ONLY: 1,
    NO_PREFERENCES: 2,
})
